module.exports = __webpack_public_path__ + "static/media/registernow.f4c4819d.png";